export default __webpack_public_path__ + "static/media/guide_strips@2x.ef13a049.png";